<template>
  <Header @toggled="onDrawerToggled" />
  <router-view />
  <Footer v-if="showFooter" />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import Footer from '@/components/footer/Footer.vue'
import Header from '@/components/header/Header.vue'

export default defineComponent({
  name: 'App',
  components: {
    Footer,
    Header
  },
  computed: {
    showFooter(): boolean {
      return this.$route.meta.showFooter
    }
  },
  methods: {
    onDrawerToggled(open: boolean): void {
      document.body.className = open ? 'drawer-open' : ''
    }
  }
})
</script>

<style lang="scss">

body {
  margin: 0;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  font-family: 'Titillium Web', sans-serif;
  margin-top: 94px;

  @include desktop {
    margin-top: 130px;
  }
}

button {
  font-family: 'Titillium Web', sans-serif;
}

.drawer-open {
  overflow: hidden;
}

* {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

</style>
